import React from "react";
import ReactDOM from "react-dom";
import "./spinner.css";
import logo from "../assets/img/greenhse-logo.png";

const AISpinner = () => {
   return ReactDOM.createPortal(
    <div className="spinner-container">
      <div className="spinner-ring"></div>
      {/* <div className="spinner-ring spinner-ring--inner"></div> */}
      {/* <img src={logo} alt="App Logo" className="spinner-logo" /> */}
      <p className="text-center fw-semibold fs-5 mt-3 text-white">Analyzing...</p>
    </div>,
    document.body
  );
};

export default AISpinner;